import { inject } from '@angular/core';
import { from, Observable, of, switchMap, tap } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider } from '@core';
import { AuthService } from '@auth/infra';

export class LogoutCommandHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  logout(): Observable<void> {
    return from(this.authService.logout()).pipe(
      tap(() => this.userDataProvider.resetUserData()),
      switchMap(() => of(void 0))
    );
  }
}
